import React, { useEffect, useState } from "react";
import { 
  useDispatch, 
  connect, 
  useSelector 
} from "react-redux";
import MetaTags from "react-meta-tags";
import { fetchDictionaryStart } from "store/dictionary/actions";
import {
  Card,
  CardBody,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import classnames from "classnames";
import Deposits from "pages/Transactions/Crypto/Deposit";
import DepositsForex from "pages/Transactions/Forex/deposits/DepositForex";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

function DepositsIndex() {
  const dispatch = useDispatch();
  useState(() => {
    dispatch(fetchDictionaryStart());
  }, []);
  const { profileMetaInfo = {} } = useSelector((state) => state.Profile);
  const toggle = (tab) => {
    if (activeTab !== tab) {
      setactiveTab(tab);
    }
  };
  const search = useLocation().search;
  const query = new URLSearchParams(search);
  const tab = query.get("tab");
  const loadTabs = ({
    transactions: { depositDetails: { forex } = {} } = {},
  }) => [
    {
      tabId: "2",
      navLinkName: "Forex",
      component: <DepositsForex />,
      hidden: !forex,
    },
  ];

  const tabs = loadTabs(profileMetaInfo).filter((item) => !item.hidden);
  const [activeTab, setactiveTab] = useState(
    tabs.length > 0 ? tabs[0].tabId : ""
  );

  useEffect(() => {
    if (tabs.length > 0) {
      setactiveTab(tabs[0].tabId);
    }
    if (tab) {
      setactiveTab(tab);
    }
  }, [profileMetaInfo]);

  return (
    <React.Fragment>
      <MetaTags>
        <title>Deposits</title>
      </MetaTags>
      <div className="page-content">
        <div className="container-fluid">
          <h2>Deposits</h2>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <TabContent activeTab={activeTab} className="p-3 text-muted">
                    {tabs.map((tabItem) => (
                      <>
                        <TabPane tabId={tabItem.tabId}>
                          <Row>
                            <Col sm="12">{tabItem.component}</Col>
                          </Row>
                        </TabPane>
                      </>
                    ))}
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
}
const mapStateToProps = (state) => ({
  loading: state.dictionaryReducer.loading || false,
  dictionary: state.dictionaryReducer.dictionary || [],
  error: state.dictionaryReducer.error,
});
export default connect(mapStateToProps, null)(DepositsIndex);
